import { Chip } from "@mui/material"

export function AutocompleteTagChip({ item, index, getTagProps }) {
    const tagProps = getTagProps({ index })
    return <Chip size="small" label={item} {...tagProps} />
}
